import { useMemo } from 'react'
import PropTypes from 'prop-types'

import Name from './Name'
import Title from './Title'
import { Typography } from 'common/widgets'


CustomTypography.propTypes = {
  variant: PropTypes.oneOf(['name', 'title']),
  className: PropTypes.string,
  children: PropTypes.node,
}

export default function CustomTypography({
  variant = undefined,
  className = undefined,
  children = undefined,
}) {
  const Component = useMemo(() => {
    switch (variant) {
    case 'name':
      return Name
    case 'title':
      return Title
    default:
      return Typography
    }
  }, [variant])

  return <Component className={className}>{children}</Component>
}
